'use strict';

var $	   = require('jquery');
var basePage = require('./base-page.js');
var gridHeights = require('./ui/grid-heights.js');


var classNames = {
	authorProfile: 'author__profile',
	longBio: 'long-bio',
    readMoreToggle: 'read-more-toggle'
};

var authorPage = {
    initAuthorBioToggle: () => {
        var authorBioFull = $.findByBem(classNames.authorProfile, classNames.longBio);
        var authorBioToggle = $.findByBem(classNames.authorProfile, classNames.readMoreToggle);

        authorBioToggle.on('click', (event) => {
            event.preventDefault();
            authorBioFull.slideDown('medium');
            authorBioToggle.hide();
        });
    }
};

basePage.init = function() {
    basePage.initBasePage();
    
    gridHeights.init();
    authorPage.initAuthorBioToggle();
};

module.exports = basePage;